import React from 'react';

const SearchV2 = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement("g", { opacity: "0.6" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.00017 1.33334C6.09656 1.33342 5.20608 1.54959 4.40301 1.96381C3.59994 2.37803 2.90756 2.97829 2.38366 3.71451C1.85976 4.45074 1.51951 5.30157 1.39131 6.19604C1.26311 7.0905 1.35067 8.00266 1.64669 8.8564C1.94271 9.71014 2.4386 10.4807 3.09299 11.1038C3.74739 11.7269 4.54131 12.1845 5.40851 12.4384C6.27572 12.6923 7.19106 12.7351 8.07818 12.5633C8.9653 12.3915 9.79847 12.01 10.5082 11.4507L12.9428 13.8853C13.0686 14.0068 13.237 14.074 13.4118 14.0725C13.5866 14.0709 13.7538 14.0008 13.8774 13.8772C14.001 13.7536 14.0711 13.5864 14.0726 13.4116C14.0741 13.2368 14.0069 13.0684 13.8855 12.9427L11.4508 10.508C12.1095 9.67242 12.5196 8.66828 12.6342 7.61049C12.7489 6.55271 12.5634 5.48402 12.099 4.52674C11.6346 3.56945 10.9101 2.76225 10.0084 2.1975C9.10665 1.63275 8.06415 1.33327 7.00017 1.33334ZM2.66684 7.00001C2.66684 5.85074 3.12338 4.74854 3.93604 3.93588C4.7487 3.12322 5.8509 2.66668 7.00017 2.66668C8.14944 2.66668 9.25164 3.12322 10.0643 3.93588C10.877 4.74854 11.3335 5.85074 11.3335 7.00001C11.3335 8.14928 10.877 9.25148 10.0643 10.0641C9.25164 10.8768 8.14944 11.3333 7.00017 11.3333C5.8509 11.3333 4.7487 10.8768 3.93604 10.0641C3.12338 9.25148 2.66684 8.14928 2.66684 7.00001Z",
      fill: "white"
    }
  ))
);

export { SearchV2 };
//# sourceMappingURL=SearchV2.js.map
